module.exports = __webpack_public_path__ + "static/media/shapes-ellipse-empty.9130d040.svg";